<template>
    <datetime v-model="localValue" :zone="'CET'" :valueZone="'CET'" v-bind="{...$props, ...$attrs}" @input="updateValue" class="datetime-picker">
        <template slot="after">
            <span class="remove-button" @click="remove" v-if="!hideRemoveButton && localValue">
                &times;
            </span>
        </template>
    </datetime>
</template>
<script>

    import {Datetime} from 'vue-datetime';
    import { DateTime as DateTimeObject } from 'luxon';

    export default {

        components: {
            Datetime
        },

        props: {
            ...Datetime.props,
            value: {
                type: String
            },
            hideRemoveButton: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                localValue: this.value,
                initialValue: this.value ? DateTimeObject.fromISO(this.value).setZone('CET').toISO() : null
            };
        },

        watch: {
            value() {
                this.localValue = this.value;
            }
        },

        methods: {
            updateValue(value) {
                if (typeof value === 'string' && value.length <= 0 || this.initialValue === value) {
                    return;
                }

                this.localValue = value;
                this.$emit('input', this.localValue);
            },

            remove() {
                this.localValue = null;
                this.$emit('input', null);
            }
        }

    }

</script>

<style lang="scss">
    .datetime-picker {
        display: flex;
        align-items: center;
        position: relative;

        .remove-button {
            position: absolute;
            right: 2px;
            display: inline-block;
            width: 20px;
            text-align: center;
            cursor: pointer;
        }
    }
</style>
